<template>
  <div
    :class="
      bem({
        l,
        r,
        t,
        b
      })
    "
  >
    <slot />
  </div>
</template>

<script>
import { create } from '../utils'

export default create({
  name: 'padding',
  props: {
    l: {
      type: Boolean,
      default: false
    },
    r: {
      type: Boolean,
      default: false
    },
    t: {
      type: Boolean,
      default: false
    },
    b: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
